export const TITLE_BLOCK = 'Help with your order';

export const FIRST_COLUMN_TITLE = 'Useful links for you';
export const SECOND_COLUMN_TITLE = 'How to';
export const THIRD_COLUMN_TITLE = 'More about';

export const FIRST_COLUMN_LINKS = 'FIRST';
export const SECOND_COLUMN_LINKS = 'SECOND';
export const THIRD_COLUMN_LINKS = 'THIRD';

export const HELP_BOX_INFO = [
  {
    title: FIRST_COLUMN_TITLE,
    columnNumber: FIRST_COLUMN_LINKS,
  },
  {
    title: SECOND_COLUMN_TITLE,
    columnNumber: SECOND_COLUMN_LINKS,
  },
  {
    title: THIRD_COLUMN_TITLE,
    columnNumber: THIRD_COLUMN_LINKS,
  },
];

const REACT_APP_MY_ACCOUNT_DOMAIN = import.meta.env.VITE_MY_ACCOUNT_DOMAIN;
export const commonLinks = [
  {
    id: 3,
    text: 'Manage your BT account online',
    link: `${REACT_APP_MY_ACCOUNT_DOMAIN}/Hub`,
    analytics: `${FIRST_COLUMN_TITLE}:Manage your BT account online`,
  },
  {
    id: 4,
    text: 'Help & support',
    link: 'https://business.bt.com/help/home/',
    analytics: `${FIRST_COLUMN_TITLE}:Help & support`,
  },
];

export const broadBandLinks = {
  [FIRST_COLUMN_LINKS]: [
    {
      id: 1,
      text: 'Your Smart Hub user guide',
      link: 'https://business.bt.com/help/guides/smart-hub-guide/',
      analytics: `${FIRST_COLUMN_TITLE}:Your Smart Hub user guide`,
    },
  ],

  [SECOND_COLUMN_LINKS]: [
    {
      id: 2,
      text: 'Set up your BT Business Broadband',
      link:
        'https://help.business.bt.com/app/categories/guide/a_id/49506/view/49505/' +
        'c/5512/?s_cid=btb_FURL_business/onboarding/broadband',
      analytics: `${SECOND_COLUMN_TITLE}:Set up your bt business broadband`,
    },
    {
      id: 3,
      text: 'Set up your 4G Assure',
      link:
        'https://help.business.bt.com/app/categories/guide/a_id/49560/view/49505/' +
        'c/5512/?s_cid=btb_FURL_business/onboarding/4GAssure',
      analytics: `${SECOND_COLUMN_TITLE}:Set up your 4G Assure`,
    },
    {
      id: 4,
      text: 'Set up your Smart Hub 2',
      link:
        'https://business.bt.com/help/guides/getting-started-with-your-bt-business-products/' +
        'setting-up-your-smart-hub-2/',
      analytics: 'Help:Set up your Smart Hub 2',
    },
    {
      id: 5,
      text: 'Set up your Hybrid Connect',
      link:
        'https://business.bt.com/help/guides/getting-started-with-your-bt-business-products/hybrid-connect/' +
        'set-up-hybrid-connect/',
      analytics: 'Help:Set up your Hybrid Connect',
    },
    {
      id: 6,
      text: 'Set up your Complete Wi-Fi',
      link:
        'https://business.bt.com/help/guides/getting-started-with-your-bt-business-products/complete-wi-fi/' +
        'set-up-complete-wi-fi/',
      analytics: 'Help:Set up your Complete Wi-Fi',
    },
  ],
  [THIRD_COLUMN_LINKS]: [
    {
      id: 2,
      text: 'Broadband',
      link:
        'https://help.business.bt.com/app/categories/guide/a_id/49506/view/49505/' +
        'c/5512/?s_cid=btb_FURL_business/onboarding/broadband',
      analytics: `${THIRD_COLUMN_TITLE}:Broadband`,
    },
    {
      id: 3,
      text: '4G Assure',
      link:
        'https://help.business.bt.com/app/categories/guide/a_id/49560/view/49505/' +
        'c/5512/?s_cid=btb_FURL_business/onboarding/4GAssure',
      analytics: `${THIRD_COLUMN_TITLE}:4g Assure`,
    },
  ],
};

export const cloudVoiceLinks = {
  [FIRST_COLUMN_LINKS]: [
    {
      id: 2,
      text: 'Your Cloud Voice Express user guide',
      link:
        'https://business.bt.com/content/dam/bt/business/v2/PDF/broadband-internet/' +
        'Yealink_W60_IP_Dect_Phone%20final.pdf',
      analytics: `${FIRST_COLUMN_TITLE}:Your cloud voice express user guide`,
    },
  ],

  [SECOND_COLUMN_LINKS]: [
    {
      id: 1,
      text: 'Set up your Cloud Voice Express',
      link:
        'https://business.bt.com/help/guides/getting-started-with-your-bt-business-products/' +
        'cloud-voice-express-cordless-phone/set-up-cloud-voice-express-cordless-phone/' +
        '?s_cid=btb_FURL_business%2Fonboarding%2Fdigitalphoneline',
      analytics: `${SECOND_COLUMN_TITLE}:Set up your Cloud Voice Express`,
    },
  ],
  [THIRD_COLUMN_LINKS]: [
    {
      id: 1,
      text: 'Cloud Voice Express',
      link:
        'https://business.bt.com/help/guides/getting-started-with-your-bt-business-products/' +
        'cloud-voice-express-cordless-phone/set-up-cloud-voice-express-cordless-phone/' +
        '?s_cid=btb_FURL_business%2Fonboarding%2Fdigitalphoneline',
      analytics: `${THIRD_COLUMN_TITLE}:Cloud Voice Express`,
    },
  ],
};
